import React from "react";
import LoadingUI from "./LoadingUI";
import "../css/LoadingLayout.css";

function LoadingLayout(props) {
    return (
        <div className="LoadingLayout-root-container">
            <div className="LoadingLayout-child card">
                {props.message ?

                    <p>{props.message.messageFromScreen}</p>
                    :
                    null
                }

                <LoadingUI />
            </div>
        </div>
    )
}

export default LoadingLayout;